module.exports = __webpack_public_path__ + "img/frame (285).48b6389a.jpg";